
<div class="modal-header">
  <h4 class="modal-title">Terms and Conditions</h4>
  <h4 class="modal-sub-title">Please Review the Terms and Conditions Carefully</h4>
</div>
<div class="modal-body">
  <mat-dialog-content>
    I, hereby confirm that I have not invested more than ₹50,00,000 across all the P2P 
    platforms in India, including www.finzy.com and hereby undertake to inform finzy 
    if my aggregate exposure from investing, across all the P2P platforms in India, 
    at any point of time is equivalent to ₹50,00,000, and understand and agree that 
    finzy shall be entitled to take any and all actions as it may deem fit.
    <br>
    <br>
    I, hereby also agree that as and when my investment across all the P2P platforms 
    in India including www.finzy.com exceed <b>₹10,00,000,</b> I will provide finzy a <a [href] ="getFileUrlByName('investorNetworthCertificate')" target="_blank"><u class="on-hover">net-worth 
    certificate</u></a> from a practicing Chartered Accountant in the attached format certifying 
    that I have net-worth of more than <b>₹50,00,000.</b>
    <br>
    <br>
    I, hereby also confirm that I have understood all the risks associated with the lending 
    transactions and finzy does not assure return of principal/payment of interest and 
    there exists a likelihood of loss of the entire principal in case of default by a borrower.
    <br>
    <br>
    I, hereby confirm to the <a href="/terms?selectedTab=Investor" target="_blank"><u class="on-hover">terms and conditions</u></a> of my finzyFlex investments
    <br>
    <br>
    I, hereby confirm to review the loan agreement with borrower and BRIDGE FINTECH SOLUTIONS
    PRIVATE LIMITED (Finzy). Sample agreement can be downloaded from <a href="https://goo.gl/Uyy8fv" target="_blank" class="info-underline"><u class="on-hover">here</u></a>.
  </mat-dialog-content>
</div>
<div class="modal-footer">
  <button type="button" mat-stroked-button class="primary secondary-btn no-text-transform"
  (click)="decline()">Disagree</button>

  <button type="button" mat-flat-button class="primary primary-btn no-text-transform continue-button"
  [mat-dialog-close]="true" cdkFocusInitial>Agree</button>
</div>
